/*global ScrollMagic TweenMax Power0 */
import React from 'react'
import styled, { css } from 'styled-components'
// import { TweenMax, Power0 } from 'gsap/all'
import ScrollMagic from 'ScrollMagic'
// import 'animation.gsap'
// import 'debug.addIndicators'

import Title from './Title'
import Container from './Container'

import signalImg from '../images/Signal.png'
import config from '../config'

const breakpoint = 1040

const Wrapper = styled.div`
  position: relative;
  /* overflow: hidden; */
`

const Text = styled.div`
  max-width: 640px;

  @media (max-width: 1180px) {
    max-width: 480px;
  }
`

const CardImg = styled.img`
  display: block;
  z-index: 2;
  position: relative;
  filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));
`

const SignalImg = styled.img`
  width: 80px;
  height: 80px;
  position: absolute;
  top: 18px;
  left: -110px;
  display: block;
  transform: rotate(-160deg);
  opacity: 0;
  transition: all 0.35s ease;

  ${props =>
    props.show &&
    css`
      opacity: 1;
    `}
`

const Card = styled.div`
  width: 440px;
  position: absolute;
  right: 0;
  bottom: 0;

  ${CardImg} {
    transform: rotate(-8deg);
    transform-origin: right bottom;
  }

  @media (max-width: ${breakpoint}px) {
    transform: translateY(168%) translateX(30%);

    ${SignalImg} {
      top: -150px;
      left: 0;
      opacity: 1 !important;
      transform: rotate(-135deg);
    }

    ${CardImg} {
      transform: rotate(12deg);
    }
  }

  @media (max-width: 400px) {
    transform: translateY(146%) translateX(30%) scale(0.8);
  }
`

const Box1 = styled.div`
  padding-top: 100px;
  padding-bottom: 100px;
  position: relative;
  border: 1px solid #fff; /* fixes wrong card child position */

  @media (max-width: 860px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }
`

const Box = styled.div`
  background: #f4f4f3;
  padding-top: 200px;
  padding-bottom: 240px;

  @media (max-width: ${breakpoint}px) {
    padding-top: 450px;
    padding-bottom: 100px;
  }

  @media (max-width: 860px) {
    padding-bottom: 30px;
  }

  @media (max-width: 400px) {
    padding-top: 380px;
  }
`

const Topline = styled.div`
  font-family: 'BentonSans';
  font-size: 20px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  margin-bottom: 4px;
  color: ${config.colors.lightblue};
`

class ContentCard extends React.Component {
  state = {
    showSignal: false,
  }

  constructor(props) {
    super(props)
    this.componentRef = React.createRef()
    this.cardRef = React.createRef()
  }

  componentDidMount() {
    this.controller = new ScrollMagic.Controller()
    const isMobile = window.innerWidth < breakpoint

    if (isMobile) {
      this.setupMobileStatic()
    } else {
      /* Fixes wrong positioning. */
      setTimeout(() => {
        this.setupDesktopMagic()
      }, 50)
    }
  }

  componentWillUnmount() {
    if (this.controller) {
      this.controller.destroy()
    }
  }

  setupDesktopMagic() {
    const componentRef = this.componentRef.current
    const cardRef = this.cardRef.current

    if (!componentRef || !cardRef) {
      return
    }

    new ScrollMagic.Scene({
      triggerElement: cardRef,
      duration: componentRef.clientHeight / 2 - 100,
    })
      .setPin(cardRef, { pushFollowers: false })
      .setTween(
        TweenMax.to(cardRef, 1, {
          rotation: 20,
          ease: Power0.easeNone,
        })
      )
      // .removeIndicators()
      // .addIndicators()
      .addTo(this.controller)
      .on('leave', ({ scrollDirection }) => {
        // console.log('LEAVE')
        cardRef.style.zIndex = '99' // fixes a rendering bug on Safari.
        if (scrollDirection !== 'FORWARD') {
          return
        }
        this.setState({ showSignal: true })
        /*
        setTimeout(() => {
          this.setState({ showSignal: false })
        }, 400)
        */
      })
  }

  setupMobileStatic() {}

  render() {
    const {
      card,
      boxOneTitle,
      boxOneText,
      boxTwoTitle,
      boxTwoText,
	  boxTwoTitleTWO,
      boxTwoTextTWO,
      topline,
    } = this.props

    return (
      <Wrapper ref={this.componentRef}>
        <Container>
          <Box1>
            <Text>
              {topline && <Topline>{topline}</Topline>}
              <Title margin>{boxOneTitle}</Title>
              {boxOneText}
            </Text>
            <Card ref={this.cardRef}>
              <SignalImg src={signalImg} alt="" show={this.state.showSignal} />
              <CardImg src={card.src} srcSet={card.srcSet} alt="" />
            </Card>
          </Box1>
        </Container>
        <Container wide noPadding>
          <Box second>
            <Container>
              <Text>
                <Title margin>{boxTwoTitle}</Title>
                {boxTwoText}
				<Title margin>{boxTwoTitleTWO}</Title>
                {boxTwoTextTWO}
              </Text>
            </Container>
          </Box>
        </Container>
      </Wrapper>
    )
  }
}

export default ContentCard
